
<template>
  <div>
    <va-modal
      v-model="showModal"
      max-width="100%"
      okText="Sauvegarder"
      cancelText="Annuler"
      v-on:cancel="closeModal"
      v-on:ok="createCustom"
      noEscDismiss
      :noOutsideDismiss="infosStatutsUpdated"
    >
      <div class="customsizeCec">
        <div class="row row-inside">
          <div class="flex md12 mb-4">
            <h5 :style="{ color: this.$themes.primary }">
              Envois personnalisés : {{ infos.nom }}
            </h5>
          </div>
          <div class="flex md1 mb-2">
            <va-checkbox class="test" label="Courrier" v-model="isCourrier" />
          </div>
          <div class="flex md2 mb-2 mr-3">
            <va-button
              :disabled="!isCourrier"
              class="offset-top"
              outline
              color="info"
              icon="fa fa-eye"
              v-on:click.middle="openPreviewPdfTab"
              @click="downloadPreviewPdf"
              >Prévisualisation</va-button
            >
          </div>
          <div class="flex md1">
            <va-checkbox label="Courriel" v-model="isEmail" />
          </div>
          <div class="flex md2 mb-2">
            <va-button
              :disabled="!isEmail"
              class="offset-top"
              outline
              color="info"
              icon="fa fa-eye"
              @click="openPreviewEmail"
              >Prévisualisation</va-button
            >
          </div>
          <div class="flex md10"></div>
          <div class="flex md12 mb-4">
            <va-tabs grow v-model="tabsState">
              <va-tab>Courrier</va-tab>
              <va-tab>Courriel</va-tab>
            </va-tabs>
          </div>
          <div
            class="flex md12"
            v-if="
              (tabsState === 0 && isCourrier) || (tabsState === 1 && isEmail)
            "
          >
            <div class="row row-inside">
              <div class="flex md6">
                <div class="row row-inside">
                  <div
                    class="flex md11 pr-3"
                    v-if="tabsState === 0 && isCourrier"
                  >
                    <va-input
                      v-model="infos.courrierSubject"
                      placeholder="Object"
                    />
                  </div>
                  <div class="flex md11 pr-3" v-if="tabsState === 1 && isEmail">
                    <va-input
                      v-model="infos.customEmail.courrielSubject"
                      placeholder="Object"
                    />
                  </div>
                  <div class="flex md11">
                    <va-medium-editor
                      :editor-options="editorOptions"
                      @initialized="handleEditorInitialization($event)"
                      class="custom-medium"
                    ></va-medium-editor>
                  </div>
                </div>
              </div>
              <div class="flex md6" v-if="tabsState === 0 && isCourrier">
                <div class="row row-inside">
                  <div class="flex md1 mb-2"></div>
                </div>
              </div>
              <div class="flex md6" v-if="tabsState === 1 && isEmail">
                <div class="row row-inside">
                  <div class="flex md1 mb-2">
                    <va-checkbox
                      label="Signature personnalisée"
                      v-model="infos.customEmail.signatureType"
                    />
                  </div>
                  <div
                    class="flex md12"
                    v-show="infos.customEmail.signatureType"
                  >
                    <va-input
                      v-model="infos.customEmail.signatureName"
                      placeholder="Signature NOM"
                    />
                  </div>
                  <div
                    class="flex md12"
                    v-show="infos.customEmail.signatureType"
                  >
                    <va-input
                      v-model="infos.customEmail.signatureFonction"
                      placeholder="Signature Fonction"
                    />
                  </div>
                  <div
                    class="flex md12"
                    v-show="infos.customEmail.signatureType"
                  >
                    <va-input
                      v-model="infos.customEmail.signatureTelephone"
                      placeholder="Signature Téléphone"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </va-modal>
    <va-modal v-model="showEmail" hideDefaultActions>
      <div class="row row-inside">
        <div class="flex md12 mb-3">
          <p>
            <u>
              <b>Sujet:</b>
            </u>
            &nbsp;&nbsp;
            {{ courrielSubject }}
          </p>
        </div>
        <div class="flex md12">
          <span v-html="customEmailHtml"></span>
        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { cloneDeep, isEqual } from "lodash";

export default {
  name: "CustomCampaign",
  props: ["value", "identreprise", "entreprise"],
  data() {
    return {
      courrielSubject: null,
      showEmail: false,
      customEmailHtml: null,
      tabsState: 0,
      isCourrier: false,
      isEmail: false,
      infosStatutsUpdated: false,
      infos: {},
      infosRef: {},
      showModal: false,
      editor: null,
      editorOptions: {
        buttonLabels: "fontawesome",
        autoLink: true,
        paste: {
          cleanPastedHTML: true,
        },
        toolbar: {
          buttons: ["bold", "italic", "underline", "anchor"],
        },
      },
    };
  },
  mounted() {
    this.resetComponent();
  },
  computed: {},
  methods: {
    handleEditorInitialization(editor) {
      if (this.tabsState === 1) {
        this.editor = editor;
        this.editor.setContent(this.infos.customEmail.body);
      } else if (this.tabsState === 0) {
        this.editor = editor;
        this.editor.setContent(this.infos.customText);
      }
    },
    async createCustom() {
      this.showModal = true;
      this.closeModal(true);
    },
    closeModal(done) {
      if (done) {
        let response = {
          identreprise: this.identreprise,
          email: null,
          courrier: null,
          courrierSubject: null,
        };

        if (this.tabsState === 1) {
          this.infos.customEmail.body = this.editor.getContent();
        } else if (this.tabsState === 0) {
          this.infos.customText = this.editor.getContent();
        }

        if (this.isCourrier) {
          response.courrier = this.infos.customText;
          response.courrierSubject = this.infos.courrierSubject;
        }
        if (this.isEmail) {
          response.email = this.infos.customEmail;
        }
        this.$emit("update", response);
      }
      this.resetComponent();
      //TODO custom infos
      //this.$emit("input", false);
      this.$emit("input", false);
    },
    resetComponent(entreprise) {
      this.isCourrier = false;
      this.isEmail = false;
      if (entreprise) {
        this.infos = entreprise;
        if (entreprise.customText) {
          this.isCourrier = true;
        }
        if (entreprise.customEmail && entreprise.customEmail.body) {
          this.isEmail = true;
        } else {
          this.infos.customEmail = {
            body: null,
            courrielSubject: null,
            signatureType: false,
            signatureName: "Pierre-Luc DAUBIGNEY",
            signatureFonction: "Secrétaire général",
            signatureTelephone: "06 45 12 53 10",
          };
        }
      } else {
        this.infos = {
          identreprise: null,
          nom: null,
          mdate_fin: null,
          email: null,
          ent_APE: null,
          contact_name: null,
          contact_main_email: null,
          set_contact_name: null,
          set_contact_email: null,
          ville: null,
          code_postal: null,
          siege_id: null,
          latest_env: null,
          max_level: null,
          comment: null,
          nbcontacts: null,
          max_levelTxt: null,
          selected: null,
          sendcourrier: null,
          showInput: null,
          sendemail: null,
          emailDisabled: null,
          customText: null,
          customEmail: {
            body: null,
            courrielSubject: null,
            signatureType: false,
            signatureName: "Pierre-Luc DAUBIGNEY",
            signatureFonction: "Secrétaire général",
            signatureTelephone: "06 45 12 53 10",
          },
          courrierSubject: null,
        };
      }
    },
    async openPreviewPdfTab() {
      let url = await this.openPreviewPdf();
      window.open(url, "_blank");
    },
    async downloadPreviewPdf(idpdf) {
      let url = await this.openPreviewPdf();
      this.downloadItem(url, "Preview");
    },
    async openPreviewPdf() {
      let entrepriseTmp = cloneDeep(this.entreprise);

      if (this.tabsState === 0) {
        this.infos.customText = this.editor.getContent();
      }
      entrepriseTmp.customText = this.infos.customText;
      entrepriseTmp.courrierSubject = this.infos.courrierSubject;
      let response = await axios.get("/api/campagne/custom-pdf", {
        params: { entreprise: entrepriseTmp },
      });
      console.log(response.data);

      return response.data;
    },
    downloadItem(url, name) {
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = name;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
    async openPreviewEmail() {
      console.log(this.editor.getContent());
      //TODO Not secure, need to be managed differently
      let entrepriseTmp = cloneDeep(this.entreprise);
      this.courrielSubject = this.infos.customEmail
        ? this.infos.customEmail.courrielSubject
        : "";
      if (this.tabsState === 1) {
        this.infos.customEmail.body = this.editor.getContent();
      }

      entrepriseTmp.customEmail = this.infos.customEmail;

      let response = await axios.get("/api/campagne/custom-email", {
        params: { entreprise: entrepriseTmp },
      });
      this.customEmailHtml = response.data;

      this.showEmail = true;
    },
  },
  watch: {
    tabsState(newvalue, oldvalue) {
      console.log(newvalue, oldvalue);
      //force switch medium editor
      //TODO investigate medium editor contamination
      if (newvalue !== oldvalue) {
        //switch from courriel to courrier
        if (newvalue === 0 && this.isEmail) {
          console.log(this.infos.customText);
          this.infos.customEmail.body = this.editor.getContent();
          this.editorOptions.toolbar.buttons = ["bold", "italic", "underline"];

          this.editor.setContent(this.infos.customText);

          //switch from courrier to courriel
        } else if (newvalue === 1 && this.isCourrier) {
          console.log(this.infos.customEmail.body);
          this.infos.customText = this.editor.getContent();
          this.editorOptions.toolbar.buttons = [
            "bold",
            "italic",
            "underline",
            "anchor",
          ];
          this.editor.setContent(this.infos.customEmail.body);
        }
      }
    },
    infos: {
      deep: true,
      handler() {
        if (!isEqual(this.infos, this.infosRef)) {
          this.infosStatutsUpdated = true;
        } else {
          this.infosStatutsUpdated = false;
        }
      },
    },
    value() {
      this.showModal = this.value;
      // Parent property changed; update internal variables
      if (!this.value) {
        this.resetComponent();
      } else if (!this.identreprise) {
        // TODO error no identreprise
        console.log("no identreprise");
      } else {
        this.resetComponent(this.entreprise);
      }
    },
  },
};
</script>

<style scoped>
.customsizeCec {
  width: 70vw;
  height: 60vh;
}

.custom-medium {
  border-radius: 10px;
  padding: 1em;
  background-color: #f6f6f6;
  height: 35vh;
  overflow: auto;
}
</style>
